export default "__VITE_ASSET__i0nScP7j__"